<button #usersBoxBtn *ngIf="orderUsers.length" class="btn btn-sm cv-btn-light btn-circular multiples-users-btn"
	(click)="toggleUsersBox()">
	<i class="fas fa-users">
		<span *ngIf="orderUsers.length" class="badge badge-pill badge-warning">
			{{ orderUsers.length }}
		</span>
	</i>
</button>
<div #usersBox class="menu-context-box cv-users-box" *ngIf="orderUsers.length">
	<div class="box-content">
		<ul>
			<li *ngFor="let user of orderUsers">
				<div class="btn-circular cv-users-box-initials">
					<span>{{ user.initials }}</span>
				</div>
				<div class="user-full-name">{{ user.fullName }}</div>
			</li>
		</ul>
	</div>
</div>
